// Shown on the customer-facing digital menu only when the restaurant's plan
// doesn't include branding removal (see PLAN_FEATURE.REMOVE_BRANDING).
const BamizbanBadge = ({ className = "" }) => (
  <p className={`pb-2 text-center text-[11px] text-gray-400 ${className}`}>
    ساخته شده با <span className="font-bold text-gray-500">بامیزبان</span>
  </p>
);

export default BamizbanBadge;
